<div class="ltms-description">{{ mainTabDiscription }}</div>
<div class="filter">
    <button *ngIf="isQuestionGroupAvialable" [ngClass]="{'active': active}" (mouseenter)="hover = true" (mouseleave)="hover = false" (click)="questionGroupClick()"><img [src]="hover || active ? 'assets/images/folder-active.svg' : 'assets/images/folder.svg'">Group Questions</button>
    <div class="filter-title">View by</div>
    <app-score-dropdown-menu [config]="viewByDropdown.config" [selectedOption]="viewByDropdown['selectedOption']" [options]="viewByDropdown.options" (selectedOptionChange)="onOptionChange($event, 'viewByDropdown')"></app-score-dropdown-menu>
    <span class="selected-option">{{ selectedOption }}</span>
    <div class="tab-comparison-right">
        <app-score-comparison-toggle [visible]="isComparisonAvailable" [showComparisonFlag]="showComparisonFlag" [dateType]="dateType" [checkboxId]="'scoreQuestionComparisonCheckbox'" (showComparisonChange)="onShowComparisonChange($event)"></app-score-comparison-toggle>
    </div>
</div>
<div class="loader" *ngIf="isLoading">
    <app-ltms-loader></app-ltms-loader>
</div>
<div class="error" *ngIf="isError && !isLoading">
    <app-ltms-error [code]="'404'"></app-ltms-error>
</div>
<div class="all-questions-table" *ngIf="selectedCardName === 'all-questions' && !isError  && !isLoading"></div>
<div class="main-container main-container--paired" *ngIf="selectedCardName === 'rating'">
    <div class="lhsBox">
        <div class="card">
            <div class="card-title">Overview</div>
            <div class="card-discription">{{ overviewDescription }}</div>
            <div class="card-loader" *ngIf="ratingCardLoading">
                <app-ltms-loader></app-ltms-loader>
            </div>
            <div class="card-loader" *ngIf="!ratingCardLoading && isRatingCardError">
                <span class="card-error">No data available for selected filter</span>
            </div>
            <div class="card-content" *ngIf="!ratingCardLoading && !isRatingCardError">
                <div class="chart-details">
                    <div class="overview-metric-block">
                        <div class="overview-metric-row">
                            <div class="response-count">{{ totalResponse }}</div>
                            <div class="overview-deviation-column" *ngIf="showComparisonFlag && shouldShowDeviation(responsesDeviation)">
                                <span class="deviation-value">{{ getPositiveValue(responsesDeviation.deviation) }}<i class="fa fa-caret-{{ responsesDeviation.arrowType }}"></i>
                                    <span class="deviation-period">vs {{ comparisonPeriodLabel }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="response-text">Responses</div>
                    </div>
                    <div class="overview-metric-block">
                        <div class="overview-metric-row">
                            <div class="response-count">{{ ratingnumber }}</div>
                            <div class="overview-deviation-column" *ngIf="showComparisonFlag && shouldShowDeviation(ratingDeviation)">
                                <span class="deviation-value">{{ getPositiveValue(ratingDeviation.deviation) }}<i class="fa fa-caret-{{ ratingDeviation.arrowType }}"></i>
                                    <span class="deviation-period">vs {{ comparisonPeriodLabel }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="response-text">{{ rating }}</div>
                    </div>
                    <div class="rating-emoji-box">
                        <div class="top">
                            <div class="response-count" *ngIf="midName">{{ topPercentage }}</div>
                            <div class="response-count" *ngIf="!midName">{{ totalTop }}({{ topPercentage }})</div>
                            <div class="response-text" *ngIf="ratingDisplay != 'NPS'">{{ topName }}</div>
                            <div class="response-text-image" *ngIf="ratingDisplay == 'NPS'"><img src="assets/images/score-question-colored-promoters.svg"></div>
                            <div class="label-hover-messgae">
                                <div [ngStyle]="{'display': 'flex'}">
                                    <div class="color-box top-box"></div>
                                    <div class="color-box-label">{{ topName }}</div>
                                </div>
                                <div>
                                    <span>{{ totalTop }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="mid" *ngIf="midName">
                            <div class="response-count">{{ midPercentage }}</div>
                            <div class="response-text" *ngIf="ratingDisplay != 'NPS'">{{ midName }}</div>
                            <div class="response-text-image" *ngIf="ratingDisplay == 'NPS'"><img src="assets/images/score-question-colored-passives.svg"></div>
                            <div class="label-hover-messgae mid-message">
                                <div [ngStyle]="{'display': 'flex'}">
                                    <div class="color-box mid-box"></div>
                                    <div class="color-box-label">{{ midName }}</div>
                                </div>
                                <div>
                                    <span>{{ totalMid }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="response-count" *ngIf="midName">{{ bottomPercentage }}</div>
                            <div class="response-count" *ngIf="!midName">{{ totalBottom }}({{ bottomPercentage }})</div>
                            <div class="response-text" *ngIf="ratingDisplay != 'NPS'">{{ bottomName }}</div>
                            <div class="response-text-image" *ngIf="ratingDisplay == 'NPS'"><img src="assets/images/score-question-colored-detractors.svg"></div>
                            <div class="label-hover-messgae bottom-message">
                                <div [ngStyle]="{'display': 'flex'}">
                                    <div class="color-box bottom-box"></div>
                                    <div class="color-box-label">{{ bottomName }}</div>
                                </div>
                                <div>
                                    <span>{{ totalBottom }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <app-score-question-bar-chart class="barchart" [chartData]="barChart"></app-score-question-bar-chart>
            </div>
        </div>
    </div>
    <div class="rhsBox">
        <div [ngClass]="{'overlay': fullScreenComponent == 'ratingBased'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent == 'ratingBased'}">
                <div class="card">
                    <div class="filter">
                        <div>
                            <div class="card-title">Trend</div>
                            <div class="card-discription">{{ trendDescription }}</div>
                        </div>
                        <span class="other-filters">
                            <app-score-widget [fullScreenButtonControl]="fullScreenComponent === 'ratingBased'" [config]="scoreWidget()" (onTrendClick)="onTrendChange($event, 'lineChart')" (onFullscreenClick)="onFullScreen($event, 'ratingBased')" (onDownloadClick)="onDownload('lineChart')"></app-score-widget>
                        </span>
                    </div>
                    <div class="lineChartLoader" *ngIf="ratingLineChartCardLoading">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lineChartLoader" *ngIf="!ratingLineChartCardLoading && isratingLineChartCardError">
                        <span class="card-error">No data available for selected filter</span>
                    </div>
                    <div class="chart" *ngIf="!ratingLineChartCardLoading && !isratingLineChartCardError">
                        <app-score-line-chart [chartPlugins]="lineChartPlugins" [chartData]="lineChart"></app-score-line-chart>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="{'overlay': fullScreenComponent == 'ratingResponseBar'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent == 'ratingResponseBar'}">
                <div class="card">
                    <div class="filter">
                        <div>
                            <div class="card-title">Response Trend</div>
                            <div class="card-discription">{{ responseTrendDescription }}</div>
                        </div>
                        <span class="other-filters">
                            <app-score-widget [fullScreenButtonControl]="fullScreenComponent === 'ratingResponseBar'" [config]="responseBarWidget()" (onTrendClick)="onTrendChange($event, 'barChart')" (onFullscreenClick)="onFullScreen($event, 'ratingResponseBar')" (onDownloadClick)="onDownload('barChart')" (onChartTypeChange)="onResponseBarChartTypeChange($event)"></app-score-widget>
                        </span>
                    </div>
                    <div class="chart barGraphLoader" *ngIf="ratingResponseBarChartLoading">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="chart barGraphLoader" *ngIf="!ratingResponseBarChartLoading && isRatingResponseBarChartError">
                        <span class="card-error">No data available for selected filter</span>
                    </div>
                    <div class="chart barGraph" *ngIf="!ratingResponseBarChartLoading && !isRatingResponseBarChartError">
                        <app-score-bar-chart [chartPlugins]="ratingTrendBarChartPlugins" [chartData]="ratingTrendBarChart"></app-score-bar-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="main-container" *ngIf="selectedCardName.includes('select')">
    <div class="lhsBox">
        <div class="card">
            <div class="card-title">Overview</div>
            <div class="card-discription">{{ overviewDescription }}</div>
            <div class="card-loader" [ngStyle]="{'height': '250px'}" *ngIf="selectionBasedCardLoading">
                <app-ltms-loader></app-ltms-loader>
            </div>
            <div class="card-loader" [ngStyle]="{'height': '250px'}" *ngIf="!selectionBasedCardLoading && selectionBasedCardError">
                <span class="card-error">No data available for selected filter</span>
            </div>
            <div class="card-content" *ngIf="!selectionBasedCardLoading && !selectionBasedCardError">
                <div class="chart-details-slectionBased">
                    <div class="overview-metric-block">
                        <div class="overview-metric-row">
                            <div class="response-count">{{ toTotalRatedOption }}</div>
                            <div class="overview-deviation-column" *ngIf="showComparisonFlag && shouldShowDeviation(responsesDeviation)">
                                <span class="deviation-value">{{ getPositiveValue(responsesDeviation.deviation) }}<i class="fa fa-caret-{{ responsesDeviation.arrowType }}"></i>
                                    <span class="deviation-period">vs {{ comparisonPeriodLabel }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="response-text">Responses</div>
                    </div>
                    <div class="overview-metric-block">
                        <div class="overview-metric-row">
                            <div class="most-selected-option">{{ mostSelectedKeyOptions?.label || '' }}<span *ngIf="mostSelectedKeyOptions?.is_deleted" class="selection-deleted-asterisk" [attr.title]="deletedOptionTooltip">*</span></div>
                            <div class="overview-deviation-column" *ngIf="showComparisonFlag && shouldShowDeviation(ratingDeviation)">
                                <span class="deviation-value">{{ getPositiveValue(ratingDeviation.deviation) }}<i class="fa fa-caret-{{ ratingDeviation.arrowType }}"></i>
                                    <span class="deviation-period">vs {{ comparisonPeriodLabel }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="response-text">Most selected</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="rhsBox">
        <div [ngClass]="{'overlay': fullScreenComponent === 'selectionBased'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent === 'selectionBased'}">
                <div class="card">
                    <div class="filter">
                        <div>
                            <div class="card-title">Trend</div>
                            <div class="card-discription">{{ trendDescription }}</div>
                        </div>
                        <span class="other-filters">
                            <app-score-widget [fullScreenButtonControl]="fullScreenComponent === 'selectionBased'" [config]="scoreWidget()" (onTrendClick)="onTrendChange($event)" (onFullscreenClick)="onFullScreen($event, 'selectionBased')" (onDownloadClick)="onDownload()" (onChartTypeChange)="onSelectionTrendChartTypeChange($event)"></app-score-widget>
                        </span>
                    </div>
                    <div class="lineChartLoader" *ngIf="ratingLineChartCardLoading">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lineChartLoader" *ngIf="!ratingLineChartCardLoading && isratingLineChartCardError">
                        <span class="card-error">No data available for selected filter</span>
                    </div>
                    <div class="chart barGraph" *ngIf="!ratingLineChartCardLoading && !isratingLineChartCardError && selectionBasedTypeChart === 'singleSelect'">
                        <app-score-bar-chart [chartPlugins]="barChartPlugins" [chartData]="barChartSingleSelect"></app-score-bar-chart>
                    </div>
                    <div class="chart" *ngIf="!ratingLineChartCardLoading && !isratingLineChartCardError && selectionBasedTypeChart === 'multiSelect'">
                        <app-score-line-chart [chartPlugins]="lineChartPluginsMultiSelect" [chartData]="lineChartMultiSelect"></app-score-line-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="selectedCardName.includes('select')" class="horizontal-bar-chart-container">
    <div class="card overview-card" [ngStyle]="{'height': 'auto'}">
        <div class="card-title">Overview</div>
        <div class="card-discription">{{ overviewDescription }}</div> 
        <div class="card-loader" [ngStyle]="{'height': '250px'}" *ngIf="selectionBasedCardLoading">
            <app-ltms-loader></app-ltms-loader>
        </div>
        <div class="card-loader" [ngStyle]="{'height': '250px'}" *ngIf="!selectionBasedCardLoading && selectionBasedCardError">
            <span class="card-error">No data available for selected filter</span>
        </div>
        <app-score-question-tab-horizonatal-bar-chart *ngIf="!selectionBasedCardLoading && !selectionBasedCardError"  [ngStyle]="{'height': horizonatlBarChartDynamicHeight}" [chartData]="horizonatlBarChart"></app-score-question-tab-horizonatal-bar-chart>
    </div>
</div>
<div class="main-container" *ngIf="selectedCardName === 'text'">
    <div class="lhsBox">
        <div class="card">
            <div class="card-title">Overview</div>
            <div class="card-discription">{{ overviewDescription }}</div>
            <div class="card-loader" *ngIf="textCardLoading">
                <app-ltms-loader></app-ltms-loader>
            </div>
            <div class="card-loader" *ngIf="!textCardLoading && isTextCardError">
                <span class="card-error">No data available for selected filter</span>
            </div>
            <div class="card-content" *ngIf="!textCardLoading && !isTextCardError">
                <div class="chart-details">
                    <div class="overview-metric-block">
                        <div class="overview-metric-row">
                            <div class="response-count">{{ totalResponse }}</div>
                            <div class="overview-deviation-column" *ngIf="showComparisonFlag && shouldShowDeviation(responsesDeviation)">
                                <span class="deviation-value">{{ getPositiveValue(responsesDeviation.deviation) }}<i class="fa fa-caret-{{ responsesDeviation.arrowType }}"></i>
                                    <span class="deviation-period">vs {{ comparisonPeriodLabel }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="response-text">Responses</div>
                    </div>
                    <div class="overview-metric-block">
                        <div class="overview-metric-row">
                            <div class="response-count">{{ ratingnumber }}</div>
                            <div class="overview-deviation-column" *ngIf="showComparisonFlag && shouldShowDeviation(ratingDeviation)">
                                <span class="deviation-value">{{ getPositiveValue(ratingDeviation.deviation) }}<i class="fa fa-caret-{{ ratingDeviation.arrowType }}"></i>
                                    <span class="deviation-period">vs {{ comparisonPeriodLabel }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="response-text">{{ rating }}</div>
                    </div>
                    <div class="rating-emoji-box">
                        <div class="top">
                            <div class="response-count" *ngIf="midName">{{ topPercentage }}</div>
                            <div class="response-count" *ngIf="!midName">{{ totalTop }}({{ topPercentage }})</div>
                            <div class="response-text" *ngIf="ratingDisplay != 'NPS'">{{ topName }}</div>
                            <div class="response-text-image" *ngIf="ratingDisplay == 'NPS'"><img src="assets/images/score-question-colored-promoters.svg"></div>
                            <div class="label-hover-messgae">
                                <div [ngStyle]="{'display': 'flex'}">
                                    <div class="color-box top-box"></div>
                                    <div class="color-box-label">{{ topName }}</div>
                                </div>
                                <div>
                                    <span>{{ totalTop }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="mid" *ngIf="midName">
                            <div class="response-count">{{ midPercentage }}</div>
                            <div class="response-text" *ngIf="ratingDisplay != 'NPS'">{{ midName }}</div>
                            <div class="response-text-image" *ngIf="ratingDisplay == 'NPS'"><img src="assets/images/score-question-colored-passives.svg"></div>
                            <div class="label-hover-messgae mid-message">
                                <div [ngStyle]="{'display': 'flex'}">
                                    <div class="color-box mid-box"></div>
                                    <div class="color-box-label">{{ midName }}</div>
                                </div>
                                <div>
                                    <span>{{ totalMid }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="response-count" *ngIf="midName">{{ bottomPercentage }}</div>
                            <div class="response-count" *ngIf="!midName">{{ totalBottom }}({{ bottomPercentage }})</div>
                            <div class="response-text" *ngIf="ratingDisplay != 'NPS'">{{ bottomName }}</div>
                            <div class="response-text-image" *ngIf="ratingDisplay == 'NPS'"><img src="assets/images/score-question-colored-detractors.svg"></div>
                            <div class="label-hover-messgae bottom-message">
                                <div [ngStyle]="{'display': 'flex'}">
                                    <div class="color-box bottom-box"></div>
                                    <div class="color-box-label">{{ bottomName }}</div>
                                </div>
                                <div>
                                    <span>{{ totalBottom }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <app-score-question-bar-chart class="barchart" [chartData]="barChart"></app-score-question-bar-chart>
            </div>
        </div>
    </div>
    <div class="rhsBox">
        <div class="card">
            <div class="filter">
                <div>
                    <div class="card-title">WordCloud</div>
                    <div class="card-discription">{{ wordcloudDescription }}</div>
                </div>
            </div>
            <div class="card-loader" *ngIf="wordCloudCardLoading" [ngStyle]="{'height': '250px'}">
                <app-ltms-loader></app-ltms-loader>
            </div>
            <div class="card-loader" *ngIf="!wordCloudCardLoading && isWordCloudCardError" [ngStyle]="{'height': '250px'}">
                <span class="card-error">No data available for selected filter</span>
            </div>
            <div id="word-cloud" [ngStyle]="{'height': '250px'}" *ngIf="!wordCloudCardLoading && !isWordCloudCardError" class="word-cloud" [ngStyle]="{'display': 'flex', 'align-item': 'center', 'justify-content': 'center'}"></div>
        </div>
    </div>
</div>
<div class="all-questions-group-table" *ngIf="selectedCardName === 'all-groups' && !isError  && !isLoading"></div>